import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import "primeicons/primeicons.css";
import "../../styles/custom-tabview.css";
import axios from "axios";

import { Dialog } from "primereact/dialog";
import NouvellesFiches from "./nouvellesFiches";
import EnCoursFiche from "./enCoursFiches";
import SuivisFiches from "./suivisFiches";
import ValidesFiches from "./validesFiches";
import RealisesFiches from "./realisesFiches";
import ToutesFiches from "./toutesLead";
import AbandonsFiche from "./abandons";
const apiUrl = process.env.REACT_APP_API_URL;

export default function LeadsList() {
const [activeIndex, setActiveIndex] = useState(() => {
  const savedIndex = localStorage.getItem("activeTabIndexLeads");
  return savedIndex !== null ? parseInt(savedIndex) : 0;
});

const [showHistorique, setShowHistorique] = useState(false);

   const handleTabChange = (e) => {
    const newIndex = e.index;
    setActiveIndex(newIndex);
    localStorage.setItem("activeTabIndexLeads", newIndex);
  };
  
 return (

<div className="relative">

 <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
        <TabPanel header="Nouvelles">
            <NouvellesFiches/>
        </TabPanel>

        <TabPanel header="En cours">
            <EnCoursFiche/>
        </TabPanel>

        <TabPanel header="Suivis">
            <SuivisFiches/>
        </TabPanel>

        <TabPanel header="Validés">
            <ValidesFiches/>
        </TabPanel>

        <TabPanel header="Réalisés">
            <RealisesFiches/>
        </TabPanel>

        <TabPanel header="Abandons">
            <AbandonsFiche/>
        </TabPanel>

        <TabPanel header="Tous">
            <ToutesFiches />
        </TabPanel>

</TabView>

</div>

 );
}